// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* This component sohuld not allow select text */
:host {
  display: block;
}

::ng-deep {
  .avatar-initials {
    -webkit-user-select: none;
            user-select: none;
  }
}

/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbImF2YXRhci1pbml0aWFscy5jb21wb25lbnQuY3NzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBLGdEQUFnRDtBQUNoRDtFQUNFLGNBQWM7QUFDaEI7O0FBRUE7RUFDRTtJQUNFLHlCQUFpQjtZQUFqQixpQkFBaUI7RUFDbkI7QUFDRiIsImZpbGUiOiJhdmF0YXItaW5pdGlhbHMuY29tcG9uZW50LmNzcyIsInNvdXJjZXNDb250ZW50IjpbIi8qIFRoaXMgY29tcG9uZW50IHNvaHVsZCBub3QgYWxsb3cgc2VsZWN0IHRleHQgKi9cbjpob3N0IHtcbiAgZGlzcGxheTogYmxvY2s7XG59XG5cbjo6bmctZGVlcCB7XG4gIC5hdmF0YXItaW5pdGlhbHMge1xuICAgIHVzZXItc2VsZWN0OiBub25lO1xuICB9XG59XG4iXX0= */`, "",{"version":3,"sources":["webpack://./src/app/shared/partials/avatar-initials/avatar-initials.component.css"],"names":[],"mappings":"AAAA,gDAAgD;AAChD;EACE,cAAc;AAChB;;AAEA;EACE;IACE,yBAAiB;YAAjB,iBAAiB;EACnB;AACF;;AAGA,wiBAAwiB","sourcesContent":["/* This component sohuld not allow select text */\n:host {\n  display: block;\n}\n\n::ng-deep {\n  .avatar-initials {\n    user-select: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
